import { Badge, EmptyState } from '@eo/shared';

import { daysUntilDropped, shortDate } from './helpers';
import { TaskCard } from './TaskCard';
import type { OverdueTabProps } from './types';

export function OverdueTab({
  groups,
  busyTaskId,
  selectedTaskId,
  onDecide,
  onEdit,
  onSelect,
}: OverdueTabProps) {
  if (groups.length === 0) {
    return (
      <EmptyState
        title="No overdue tasks"
        description="Every task from an earlier meeting has been decided. Anything new waits on its own day."
      />
    );
  }

  return (
    <div data-testid="overdue-tab" className="flex flex-col gap-6">
      {groups.map((group) => {
        const left = daysUntilDropped(group.daysWaiting);

        return (
          <section key={group.date} className="flex flex-col gap-2">
            <div className="flex items-baseline gap-2">
              <h2 className="text-sm font-semibold text-text-primary">{shortDate(group.date)}</h2>
              <span className="text-xs text-text-tertiary">
                {group.drafts.length} task{group.drafts.length === 1 ? '' : 's'} · waiting{' '}
                {group.daysWaiting} day{group.daysWaiting === 1 ? '' : 's'}
              </span>
              <Badge variant={left <= 7 ? 'danger' : 'warning'}>{left} days left</Badge>
            </div>
            <div className="flex flex-col gap-2">
              {group.drafts.map((draft) => (
                <TaskCard
                  key={draft.taskId}
                  draft={draft}
                  // The group heading carries the day, so the card names the
                  // meeting instead — several meetings can share one date.
                  eyebrow={draft.meetingTitle || 'Untitled meeting'}
                  busy={busyTaskId === draft.taskId}
                  selected={selectedTaskId === draft.taskId}
                  disabled={busyTaskId !== null && busyTaskId !== draft.taskId}
                  onDecide={(decision) => onDecide(draft, decision)}
                  onEdit={() => onEdit(draft.taskId)}
                  onSelect={() => onSelect(draft.taskId)}
                />
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
}
